<template>
  <div>
    <app-helpButton/>
    <app-header/>
    <div>
      <div>
        <app-sidebar syle="position:fixed"/>
      </div>
      <div>
        <div class="fondNoir" v-if="afficheFondNoir">
        </div>
        <div class="is-main-content">
          <div class="columns is-fullheight">
            <div class="column is-12">
              <transition name="slide" mode="out-in">
                <router-view :key="$route.fullPath"></router-view>
              </transition>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      @close="hidePopup()"
      :active="popUpPermission"
      class="modal"
      width="380px"
      has-modal-card>
      <app-pop-up-permission/>
    </b-modal>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import popUpPermission from '@/components/menu/p_popUpPermissions';
import Header from './Header';
import Sidebar from './sideBar/Sidebar';
import HelpButton from './helpButton/HelpButton';

const Ui = createNamespacedHelpers('ui');
const Permissions = createNamespacedHelpers('permissions');

export default {
  name: 'App',
  components: {
    appPopUpPermission: popUpPermission,
    appHeader: Header,
    appSidebar: Sidebar,
    appHelpButton: HelpButton,
  },
  data() {
    return {
    };
  },
  computed: {
    ...Ui.mapGetters({
      afficheFondNoir: 'afficheFondNoir',
    }),
    ...Permissions.mapGetters({
      popUpPermission: 'popup',
    }),
  },
  methods: {
    ...Permissions.mapActions({
      hidePopup: 'hidePopup',
    }),
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
